import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Tooltip } from "@material-ui/core";
import ChatiaPopover from "../ChatiaPopover";
import useActionBtnStyles from "../../styles/actionBtnStyles";

/** Cores fixas das colunas — sem color picker (decisão de design). */
export const LANE_COLOR_PRESETS = [
  "#1976d2", "#42a5f5", "#0ea5e9", "#3B82F6",
  "#7e57c2", "#8B5CF6", "#10B981", "#22c55e",
  "#F59E0B", "#F97316", "#ef4444", "#c62828",
  "#9CA3AF", "#475569",
];

const useStyles = makeStyles((theme) => {
  const ds = theme.chatiaDS || {};
  const radius = ds.radius || { sm: 10, md: 12, full: 50 };
  const isDark = theme.mode === "dark" || theme.palette?.type === "dark";
  return {
    body: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      padding: 12,
      minWidth: 320,
    },
    swatchRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: 6,
    },
    swatch: {
      width: 22,
      height: 22,
      borderRadius: radius.full,
      cursor: "pointer",
      border: `2px solid transparent`,
      transition: "transform 0.1s, border-color 0.15s",
      "&:hover": { transform: "scale(1.08)" },
    },
    swatchSelected: {
      borderColor: isDark ? "#fff" : "#111",
      boxShadow: "0 0 0 2px rgba(25,118,210,0.25)",
    },
    fieldLabel: {
      fontSize: 11,
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: 0.5,
      color: ds.colors?.textSecondary || (isDark ? "#8696a0" : "#667781"),
      marginBottom: 4,
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: 4,
    },
    lockedBanner: {
      padding: "6px 10px",
      borderRadius: radius.sm,
      background: isDark ? "rgba(255,193,7,0.1)" : "#fff8e1",
      color: isDark ? "#ffd54f" : "#8a6d3b",
      fontSize: 12,
    },
  };
});

const AddColumnPopover = ({
  open,
  anchorEl,
  onClose,
  onSave,
  saving,
  title = "Nova coluna",
  initialName = "",
  initialColor = "#1976d2",
}) => {
  const classes = useStyles();
  const btn = useActionBtnStyles();
  const [name, setName] = useState(initialName);
  const [color, setColor] = useState(initialColor);

  useEffect(() => {
    if (open) {
      setName(initialName);
      setColor(initialColor);
    }
  }, [open, initialName, initialColor]);

  const canSave = !saving && name.trim().length >= 1;

  const handleSubmit = () => {
    if (!canSave) return;
    onSave?.({
      name: name.trim(),
      color,
    });
  };

  return (
    <ChatiaPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      title={title}
      paperStyle={{ minWidth: 340 }}
      contentStyle={{ padding: 0, maxHeight: "none", overflow: "visible" }}
    >
      <div className={classes.body}>
        <TextField
          label="Nome da coluna"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSubmit(); } }}
          variant="outlined"
          margin="dense"
          autoFocus
          fullWidth
          InputProps={{ style: { borderRadius: 12 } }}
        />
        <div>
          <div className={classes.fieldLabel}>Cor</div>
          <div className={classes.swatchRow}>
            {LANE_COLOR_PRESETS.map((c) => (
              <Tooltip key={c} title={c}>
                <div
                  className={`${classes.swatch} ${c === color ? classes.swatchSelected : ""}`}
                  style={{ background: c }}
                  onClick={() => setColor(c)}
                />
              </Tooltip>
            ))}
          </div>
        </div>
        <div className={classes.actions}>
          <button
            type="button"
            className={btn.dialogBtn}
            onClick={handleSubmit}
            disabled={!canSave}
          >
            {saving ? "Salvando…" : "Salvar"}
          </button>
        </div>
      </div>
    </ChatiaPopover>
  );
};

export default AddColumnPopover;
